import React, {useState, useEffect} from 'react';
import { FaInfo } from 'react-icons/fa';
import { FiMaximize } from 'react-icons/fi';

const Login = ({ isAuthenticated, user, onLogin, openModal, toggleSound, isSoundOn, volume, setVolume }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showVolumeControl, setShowVolumeControl] = useState(false);

  const handleMaxMin = () => {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
  };

  const handlePageClose = () => {
    window.close();
  };

  const handleMouseEnter = () => {
    if (isSoundOn) {
      setShowVolumeControl(true);
    }
  };

  const handleMouseLeave = () => {
    setShowVolumeControl(false);
  };

  const handleScroll = (event) => {
    const delta = event.deltaY;
    setVolume((prevVolume) => {
      let newVolume = prevVolume + (delta > 0 ? -5 : 5); // Adjust volume based on scroll direction
      newVolume = Math.max(0, Math.min(100, newVolume)); // Ensure volume stays within 0-100 range
      return newVolume;
    });
  };

  useEffect(() => {
    const updateFullscreenState = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', updateFullscreenState);

    return () => {
      document.removeEventListener('fullscreenchange', updateFullscreenState);
    };
  }, []);

  const playButtonClickSound = () => {
    const audio_click = new Audio('sound/button_sound/Info_BTN.ogg');
    const audio_show = new Audio('sound/button_sound/Info_LST.ogg');
    audio_click.addEventListener('ended', () => {
      audio_show.play();
    });
  
    audio_click.volume = volume / 100;
    audio_show.volume = volume / 100;

    audio_click.play();
  };

  const loginButtonClickSound = () => {
    const audio_login_click = new Audio('sound/button_sound/Login_BTN.ogg');
    audio_login_click.volume = volume / 100;
    audio_login_click.play();
  }

  return (
    <>
      <div className="login-but-div">
          {isAuthenticated ? (
              <button className="common-but login-but" onClick={onLogin}>{user.name}</button>
          ) : (
              <button className="common-but login-but" onClick={() => { onLogin(); isSoundOn && loginButtonClickSound(); }}>Login</button>
          )}
          <button 
          className={`${isSoundOn ? 'sound-on-but' : 'sound-off-but'}`} 
          onClick={toggleSound} 
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave}
          onWheel={handleScroll}
          >
          </button>
          <button className="info-but" onClick={() => { openModal(); isSoundOn && playButtonClickSound(); }}>
              {/* <FaInfo /> */}
          </button>
          
          <button className={`${isFullscreen ? 'min-but' : 'max-but'}`} onClick={handleMaxMin}>
          </button>
      </div>
      {showVolumeControl && (
        <div className="volume-control-panel">
          <input className="volume-slider" type="range" min="0" max="100" value={volume} onChange={(e) => setVolume(e.target.value)} />
        </div>
      )}
    </>
  );
};

export default Login;
